import axios from "../../axios/index.js"


export default {
   GetAll(no) {
    return axios.get("/factures/getAll/"+no,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
}
